import { render, staticRenderFns } from "./DiyActivity.vue?vue&type=template&id=27cd4ca5&scoped=true&"
import script from "./DiyActivity.vue?vue&type=script&lang=js&"
export * from "./DiyActivity.vue?vue&type=script&lang=js&"
import style0 from "./DiyActivity.vue?vue&type=style&index=0&id=27cd4ca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd4ca5",
  null
  
)

export default component.exports